var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout-btn",on:{"click":_vm.logout}},[_vm._v("退出系统")])}
var staticRenderFns = []

export { render, staticRenderFns }